export default __webpack_public_path__ + "static/media/inventory.30106663.svg";